import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoHomeOutline, IoHeartOutline, IoGridOutline, IoPersonOutline } from "react-icons/io5";
import { FiArrowLeft } from "react-icons/fi";

const categories = [
  "Baby Care",
  "Fashion & Beauty",
  "Personal Cares",
  "Electronics & Gadgets",
  "Phones & Accessories",
];

const categoryData = {
  "Baby Care": [
    { id: 1, name: "View All", image: "https://placehold.co/100x100?text=View+All" },
    { id: 2, name: "Diapers", image: "https://placehold.co/100x100?text=Diapers" },
    { id: 3, name: "Wipes", image: "https://placehold.co/100x100?text=Wipes" },
    { id: 4, name: "Baby Food", image: "https://placehold.co/100x100?text=Baby+Food" },
    { id: 5, name: "Bath & Skin", image: "https://placehold.co/100x100?text=Bath+%26+Skin" },
    { id: 6, name: "Baby Gear", image: "https://placehold.co/100x100?text=Baby+Gear" },
    { id: 7, name: "Feeding", image: "https://placehold.co/100x100?text=Feeding" },
    { id: 8, name: "Toys", image: "https://placehold.co/100x100?text=Toys" },
  ],
  "Fashion & Beauty": [
    { id: 1, name: "View All", image: "https://placehold.co/100x100?text=View+All" },
    { id: 2, name: "Men's Wear", image: "https://placehold.co/100x100?text=Men's+Wear" },
    { id: 3, name: "Women's Wear", image: "https://placehold.co/100x100?text=Women's+Wear" },
    { id: 4, name: "Shoes", image: "https://placehold.co/100x100?text=Shoes" },
    { id: 5, name: "Watches", image: "https://placehold.co/100x100?text=Watches" },
    { id: 6, name: "Bags", image: "https://placehold.co/100x100?text=Bags" },
    { id: 7, name: "Beauty Tools", image: "https://placehold.co/100x100?text=Beauty+Tools" },
    { id: 8, name: "Makeup", image: "https://placehold.co/100x100?text=Makeup" },
  ],
  "Personal Cares": [
    { id: 1, name: "View All", image: "https://placehold.co/100x100?text=View+All" },
    { id: 2, name: "Skin Care", image: "https://placehold.co/100x100?text=Skin+Care" },
    { id: 3, name: "Hair Care", image: "https://placehold.co/100x100?text=Hair+Care" },
    { id: 4, name: "Oral Care", image: "https://placehold.co/100x100?text=Oral+Care" },
    { id: 5, name: "Fragrances", image: "https://placehold.co/100x100?text=Fragrances" },
    { id: 6, name: "Grooming", image: "https://placehold.co/100x100?text=Grooming" },
    { id: 7, name: "Body Care", image: "https://placehold.co/100x100?text=Body+Care" },
    { id: 8, name: "Wellness", image: "https://placehold.co/100x100?text=Wellness" },
  ],
  "Electronics & Gadgets": [
    { id: 1, name: "View All", image: "https://placehold.co/100x100?text=View+All" },
    { id: 2, name: "Audio", image: "https://placehold.co/100x100?text=Audio" },
    { id: 3, name: "Smart Home", image: "https://placehold.co/100x100?text=Smart+Home" },
    { id: 4, name: "Wearables", image: "https://placehold.co/100x100?text=Wearables" },
    { id: 5, name: "Cameras", image: "https://placehold.co/100x100?text=Cameras" },
    { id: 6, name: "Gaming", image: "https://placehold.co/100x100?text=Gaming" },
    { id: 7, name: "Laptops", image: "https://placehold.co/100x100?text=Laptops" },
    { id: 8, name: "Accessories", image: "https://placehold.co/100x100?text=Accessories" },
  ],
  "Phones & Accessories": [
    { id: 1, name: "View All", image: "https://placehold.co/100x100?text=View+All" },
    { id: 2, name: "Smartphones", image: "https://placehold.co/100x100?text=Smartphones" },
    { id: 3, name: "Chargers", image: "https://placehold.co/100x100?text=Chargers" },
    { id: 4, name: "Cases", image: "https://placehold.co/100x100?text=Cases" },
    { id: 5, name: "Earphones", image: "https://placehold.co/100x100?text=Earphones" },
    { id: 6, name: "Power Banks", image: "https://placehold.co/100x100?text=Power+Banks" },
    { id: 7, name: "Screen Protectors", image: "https://placehold.co/100x100?text=Screen+Protectors" },
    { id: 8, name: "Cables", image: "https://placehold.co/100x100?text=Cables" },
  ],
};

const CategoryScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState("Baby Care");

  return (
    <div className="flex flex-col bg-gray-50 h-screen">
      <header className="sticky top-0 z-10 bg-white shadow-sm mb-5">
        <div className="p-4 flex items-center justify-center relative">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="absolute left-4"
            aria-label="Go back"
          >
            <FiArrowLeft className="h-5 w-5 text-gray-800" />
          </button>
          <h1 className="text-base font-semibold text-gray-900">Category</h1>
        </div>
      </header>

      <div className="flex flex-1 overflow-hidden">
        <div className="w-[30%] bg-gray-100 overflow-y-auto space-y-5 gap-y-5">
          {categories.map((category) => {
            if (activeCategory === category) {
              return (
                <button
                  key={category}
                  type="button"
                  className="w-full text-left px-2 py-2 text-sm rounded bg-white border-l-4 border-[#19C463] font-semibold p-2 text-[12px] cursor-default"
                  disabled
                >
                  {category}
                </button>
              );
            } else {
              return (
                <button
                  key={category}
                  type="button"
                  onClick={() => setActiveCategory(category)}
                  className="w-full text-left px-2 py-2 text-sm rounded text-gray-600"
                >
                  {category}
                </button>
              );
            }
          })}
        </div>

        <div className="w-[70%] bg-white overflow-y-auto p-4">
          <div className="grid grid-cols-3 gap-6">
            {categoryData[activeCategory].map((item) => (
              <div
                key={`${activeCategory}-${item.id}-${item.name}`}
                className="flex flex-col items-center cursor-pointer p-1 gap-x-2.5"
              >
                <img
                  loading="lazy"
                  src={item.image}
                  alt={item.name}
                  className="w-20 h-20 rounded-full object-cover"
                />
                <p className="text-[12px] font-semibold text-center p-2" style={{ color: '#000000' }}>
                  {item.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <nav className="fixed bottom-0 inset-x-0 bg-white shadow-[0_-2px_10px_rgba(0,0,0,0.08)]">
        <div className="flex items-center justify-around py-3">
          <button
            type="button"
            onClick={() => navigate("/home")}
            className="flex flex-col items-center gap-1"
            style={{ color: location.pathname === "/home" ? "#19C463" : "#000000" }}
          >
            <IoHomeOutline className="h-6 w-6" />
            <span className="p-1 text-sm">Home</span>
          </button>
          <button
            type="button"
            className="flex flex-col items-center gap-1"
            style={{ color: "#000000" }}
          >
            <IoHeartOutline className="h-6 w-6" />
            <span className="p-1 text-sm">Wishlist</span>
          </button>
          <button
            type="button"
            onClick={() => navigate("/category")}
            className="flex flex-col items-center gap-1"
            style={{ color: location.pathname === "/category" ? "#19C463" : "#000000" }}
          >
            <IoGridOutline className="h-6 w-6" />
            <span className="p-1 text-sm">Category</span>
          </button>
          <button
            type="button"
            onClick={() => navigate("/profile")}
            className="flex flex-col items-center gap-1"
            style={{ color: location.pathname === "/profile" ? "#19C463" : "#000000" }}
          >
            <IoPersonOutline className="h-6 w-6" />
            <span className="p-1 text-sm">Profile</span>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default CategoryScreen;
